/**
 * "Ns to make the first move" — the old `FirstMoveTimerBanner` look
 * (`components/PlayerComponent/FirstMoveTimerBanner.js` L40-66): the copy on a
 * light-yellow ground, centred in the row.
 *
 * `CCColors.LightYellow` -> `tokens.well` (the gold tint of the CircleChess
 * palette), the closest existing token; `theme/tokens.ts` is shared with the web
 * byte-for-byte, so nothing was added to it.
 */
import React from 'react';
import {StyleSheet, View} from 'react-native';

import {RADIUS, SPACE} from '../../theme/tokens';
import {useV2Theme} from '../../theme/useV2Theme';
import {Txt} from '../../ui';
import {FirstMoveBannerModel} from './FirstMoveBanner.model';

export default React.memo(function FirstMoveBannerView({
  visible,
  seconds,
}: FirstMoveBannerModel) {
  const tokens = useV2Theme(s => s.tokens);
  if (!visible) {
    return null;
  }
  return (
    <View
      testID="v2-first-move-banner"
      style={[styles.banner, {backgroundColor: tokens.well}]}>
      <Txt variant="helper" tone="ink2" numeric>
        {seconds}s to make the first move
      </Txt>
    </View>
  );
});

const styles = StyleSheet.create({
  banner: {
    flexShrink: 1,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: SPACE.sm,
    paddingVertical: 2,
    borderRadius: RADIUS.badge,
  },
});
